import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import ReactPlayer from 'react-player';

import SubmitButton from '../common/SubmitButton';
import Alerts from '../common/Alerts';
import Translation from '../common/Translation';
import CancelButton from '../common/CancelButton';
import Input from '../common/Input';
import Link from '../../entities/link';
import { nameofFactory } from '../../helpers/nameOfFactory';
import * as enums from '../../common/enums';
import { BaseDetailProps } from '../common/types/baseDetail';
import DropDown from '../common/DropDown';

const nameof = nameofFactory<Link>();

export interface LinkDetailProps extends BaseDetailProps<Link>, LinkDetailStateProps {
    headerText: string;
}

export interface LinkDetailStateProps {
    lang: string;
}

class LinkDetail extends Component<LinkDetailProps> {
    handleOnSubmit = (values: object) => {
        this.props.submitAction(values as Link);
    };

    handleOnCancel = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();

        this.props.cancelAction();
    };

    translatedFormValidation = (values: object) => {
        const { t } = this.props;

        const typedValues = values as Link;
        const errors: Partial<Record<keyof Link, string>> = {};

        if (!typedValues.key) {
            errors.key = t('KeyIsRequired');
        }

        if (!typedValues.value) {
            errors.value = t('ValueIsRequired');
        }

        return errors;
    };

    render() {
        const { initialValues, headerText, cancelAction } = this.props;

        return (
            <div>
                <div className="content-header">
                    <h1>{headerText}</h1>
                </div>
                <div className="content-wrapper">
                    <Alerts />
                    <div className="panel card col-xs-12 col-sm-6">
                        <Form
                            validate={this.translatedFormValidation}
                            onSubmit={this.handleOnSubmit}
                            initialValues={initialValues}
                            render={({ handleSubmit, form }) => (
                                <form className="k-form" onSubmit={handleSubmit}>
                                    <label className="k-form-field" htmlFor={nameof('key')}>
                                        <span>
                                            <Translation tKey="Key" />
                                        </span>
                                        <Field name={nameof('key')} component={Input} />
                                    </label>
                                    <label className="k-form-field" htmlFor={nameof('value')}>
                                        <span>
                                            <Translation tKey="Link" />
                                        </span>
                                        <Field name={nameof('value')} component={Input} />
                                    </label>

                                    <label className="k-form-field" htmlFor={nameof('languageEnumDescription')}>
                                        <span>
                                            <Translation tKey="Language" />
                                        </span>
                                        <Field
                                            name={nameof('languageEnumDescription')}
                                            component={DropDown}
                                            textField="text"
                                            dataSource={enums.LANGUAGE_TYPES}
                                        />
                                    </label>

                                    <label className="k-form-field" htmlFor={nameof('typeEnumDescription')}>
                                        <span>
                                            <Translation tKey="Type" />
                                        </span>
                                        <Field
                                            name={nameof('typeEnumDescription')}
                                            component={DropDown}
                                            textField="text"
                                            dataSource={enums.LINK_TYPE_TYPES}
                                        />
                                    </label>

                                    <label className="k-form-field" htmlFor="preview">
                                        <span>
                                            <Translation tKey="Preview" />
                                        </span>

                                        {form.getFieldState(nameof('value')) && form.getFieldState(nameof('value')).value && (
                                            <ReactPlayer url={form.getFieldState(nameof('value')).value} />
                                        )}
                                    </label>

                                    <div className="footer">
                                        <SubmitButton loading={form.getState().submitting}>
                                            <Translation tKey="Save" />
                                        </SubmitButton>
                                        <CancelButton onClick={this.handleOnCancel}>
                                            <Translation tKey="Cancel" />
                                        </CancelButton>
                                    </div>
                                </form>
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any): LinkDetailStateProps => {
    return {
        lang: state.app.lang,
    };
};

export default connect(mapStateToProps)(LinkDetail);
